export interface EntitySchemaCheckOptions {

    /**
     * Check constraint name.
     */
    name?: string;

    /**
     * Check expression.
     */
    expression: string;

}